<template>
    <section class="search-page yeggi-bg">
        <div class="top-bar m-b-md">
            <div class="top-bar--left">
                <b-button @click="selectTab(0)" size="-tab" variant="-gray"
                          :class="{ 'btn--primary': tabIndex === 0 }">3D Printer OS
                </b-button>
                <b-button @click="selectTab(1)" size="-tab" variant="-gray"
                          :class="{ 'btn--primary': tabIndex === 1 }">Yeggi
                </b-button>
                <img v-if="tabIndex === 1" class="yeggi-copy" alt="yeggi copyright" src="https://cloud.3dprinteros.com/assets/i/yeggi_logo_3.png">
            </div>
            <div class="top-bar--right">
                <b-form-input placeholder="Search for 3D models and gcodes" v-model="search"  class="inp inp--combo"></b-form-input>
                <b-button @click="clickButtonSearch" variant="-combo btn--ternary btn--outline"><i class="icon icon--search"></i></b-button>
            </div>
        </div>

        <div class="m-b-md">
            <!--<div v-if="tabIndex === 1">-->
                <!--<div class="pull-left m-b-md">-->
                    <!--<b-button variant="danger">Random</b-button>-->
                    <!--<b-button variant="success">Popular</b-button>-->
                <!--</div>-->
            <!--</div>-->


            <b-row class="output-row">
                <b-card

                        :key="index"
                        v-for="(item, index) in items"
                        :title='fileNameCut(item.m_title)'
                        :img-src="item.m_img_url + '?image=' + parseInt(index  + 1)"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="output-card"
                >
                    <b-card-text>

                    </b-card-text>

                    <b-button v-if="(item.m_page_name == 'Thingiverse' || item.m_page_name  == 'Internal') && !item.isLoad && !item.isMyFiles" @click="saveFile(item)"  variant="-primary btn--small">Add model</b-button>
                    <b-button v-if="(item.m_page_name != 'Thingiverse' && item.m_page_name  != 'Internal')"  @click="goToUrl(item.m_url)" variant="-primary btn--small">Download ↗</b-button>




                    <b-button v-if="item.isMyFiles"  @click="goTo()" variant="-primary btn--small">Added to files</b-button>

                    <b-button v-if="item.isLoad"  variant="-primary btn--small" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        Loading...
                    </b-button>

                </b-card>
            </b-row>
            <div>
                <container-loader v-if="isLoad"></container-loader>
            </div>
        </div>

<!--        TODO: insert files table -->
    </section>
</template>

<script>
  import File from '@/mixins/file'
    export default {
        name: "Dashboard",
        mixins: [File],
        data() {
            return {
                search: '',
                engines: 'yeggi',
                tabIndex: 1,
                items: [],
                page: 0,
                f: 'downloadable',
                isLoad: true,
            }
        },
      computed: {
        filesSearch(){
          return this.items.filter(item => {
            return item.name.toLowerCase().includes(this.search.toLowerCase())
          })
        },
        inputSearch() {
          return  this.search === '' && this.tabIndex === 1 ?  '3DPrinterOS Duck' : this.search;
        }
      },
      methods: {
        goToUrl(url){
          let win = window.open(url, '_blank');
          win.focus();
        },
        goTo(){
          this.$router.push('/files')
        },
        selectTab(tabIndex){
          this.tabIndex = tabIndex;
          this.items = [];
          this.engines = tabIndex === 1 ? 'yeggi': 'internal';
          this.t = tabIndex === 1 ? 'downloadable': '';
          this.page = 0;
          this.getSearch();

        },
        clickButtonSearch(){
          this.items = [];
          this.page =  0;
          this.getSearch()
        },
        getSearch(){
          this.isLoad = true;
          window.axios.get(process.env.VUE_APP_API_URL  + '/search/addpage?p=' + this.page + '&q='+ this.inputSearch + '&f='+ this.t +'&s=' + this.engines).then((response) => {
            response.data.forEach((item)=>{
              item.isLoad = false;
              this.items.push(item)
            });
            this.isLoad = false
            this.isMyFiles = false
          })
        },
        saveFile(file){
          file.isLoad = true;
          window.axios.post(process.env.VUE_APP_API_URL + 'search/addfile', {
            d: file.m_id,
            url: file.m_url,
            name: file.m_title,
            s: this.engines
          }).then((response) => {
            console.log(response);
            file.isLoad = false;
            file.isMyFiles = true;
          })

        },
        scroll(){
          window.onscroll = () => {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

            if (bottomOfWindow) {
              this.page += 1;
              this.getSearch()
            }
          };
        }

      },
      created() {

          this.getSearch();
      },
      mounted() {
        this.scroll();
      }

    }
</script>

<style lang="scss">
    @import ".././scss/theme";
    .search-page {
        .inp {
            width: 420px;
        }
        .yeggi-copy {
            opacity: .2;
            height: 36px;
            margin-top: 4px;
        }
        .top-bar {
            margin-bottom: 12px;
        }
    }
    .output {
        &-row {
            max-width: 1360px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
        }

        &-card {
            margin: 16px;
            cursor: pointer;
            flex: 0 1 calc(14%);
            color: white;
            border-radius: $s-border-radius;

            .card-body {
                border-bottom-left-radius: $s-border-radius;
                border-bottom-right-radius: $s-border-radius;
                position: absolute;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                width: 100%;
                height: 100%;
                opacity: 0;
                transition: .2s all;
                background: rgba(black, .7);
                transform: scale(.95);

                h4 {
                    font-size: 16px;
                    margin-bottom: 4px;
                }

                .btn {
                    margin-top: 24px;
                }
            }
            &:hover {
                .card-body {
                    transition: .3s all;
                    opacity: 1;
                    transform: unset;
                }
            }
        }
    }
</style>
